import React from "react";
import { STATUS_STYLES } from "@/lib/constants";

export const StatusBadge = ({ status }) => (
  <span
    data-testid={`status-badge-${status}`}
    className={`inline-flex items-center rounded-full border px-2.5 py-1 text-xs font-semibold ${
      STATUS_STYLES[status] || "bg-slate-500/15 text-slate-300 border-slate-500/40"
    }`}
  >
    {status}
  </span>
);
